<template>
  <div class="c-simple-form-box">
    <div class="c-simple-form-box__content">
      <form novalidate>
        <div class="grid-container">
          <div class="c-simple-form-box__section">
            <h2 class="c-simple-form-box__heading" v-if="headingBlockOne">{{headingBlockOne}}</h2>
            <div class="grid-x grid-margin-x o-columns__two">
              <div class="cell">
                <form-select
                  name="title"
                  v-bind:id="'title'"
                  v-bind:label="renderText(titleLabel, 'Title')"
                  v-bind:options="titleOptions"
                  v-bind:required="true"
                  v-bind:validationError="titleError"
                  v-bind:validationMessage="titleValidationMessage"
                  v-model="innerTitle"
                  v-on:change="valueChange($event, 'title')"
                ></form-select>
              </div>

              <div class="cell" v-if="showOtherTitle">
                <form-input
                  name="other-title"
                  v-bind:id="'otherTitle'"
                  v-bind:label="renderText(otherTitleLabel, 'Other title')"
                  v-bind:required="true"
                  v-bind:validationError="otherTitleError"
                  v-bind:validationMessage="otherTitleValidationMessage"
                  v-if="showOtherTitle"
                  v-model="innerOtherTitle"
                  v-on:input="valueChange($event, 'otherTitle')"
                ></form-input>
              </div>
              <div class="cell">
                <form-input
                  name="name"
                  v-bind:id="'firstName'"
                  v-bind:label="renderText(firstNameLabel, 'First name')"
                  v-bind:required="true"
                  v-bind:validationError="firstNameError"
                  v-bind:validationMessage="firstNameValidationMessage"
                  v-model="innerFirstName"
                  v-on:input="valueChange($event, 'firstName')"
                ></form-input>
              </div>
              <div class="cell">
                <form-input
                  name="lastName"
                  v-bind:id="'lastName'"
                  v-bind:label="renderText(lastNameLabel, 'Last name')"
                  v-bind:required="true"
                  v-bind:validationError="lastNameError"
                  v-bind:validationMessage="lastNameValidationMessage"
                  v-model="innerLastName"
                  v-on:input="valueChange($event, 'lastName')"
                ></form-input>
              </div>
              <div class="cell">
                <form-input
                  name="email"
                  v-bind:id="'email'"
                  v-bind:label="renderText(emailLabel, 'Email')"
                  v-bind:required="true"
                  v-bind:validationError="emailError"
                  v-bind:validationMessage="emailValidationMessage"
                  v-model="innerEmail"
                  v-on:input="valueChange($event, 'email')"
                ></form-input>
              </div>
              <div class="cell">
                <form-input
                  name="extraDetails"
                  v-bind:id="'extraDetails'"
                  v-bind:label="renderText(extraDetailsLabel, 'Organisation')"
                  v-bind:required="true"
                  v-bind:validationError="extraDetailsError"
                  v-bind:validationMessage="extraDetailsValidationMessage"
                  v-model="innerExtraDetails"
                  v-on:input="valueChange($event, 'extraDetails')"
                ></form-input>
              </div>
              <div class="cell">
                <form-input
                  name="number"
                  type="tel"
                  v-bind:id="'number'"
                  v-bind:label="renderText(numberLabel, 'Contact number')"
                  v-bind:required="true"
                  v-bind:validationError="numberError"
                  v-bind:validationMessage="numberValidationMessage"
                  v-model="innerNumber"
                  v-on:input="valueChange($event, 'number')"
                ></form-input>
              </div>
            </div>
          </div>
          <div class="c-simple-form-box__section">
            <h2 class="c-simple-form-box__heading" v-if="headingBlockTwo">{{headingBlockTwo}}</h2>
            <div class="grid-x grid-margin-x o-columns__two">
              <div class="cell">
                <form-input
                  name="first-line-of-address"
                  v-bind:id="'firstLineOfAddress'"
                  v-bind:label="renderText(firstLineOfAddressLabel, 'Property name / number')"
                  v-bind:required="true"
                  v-bind:validationError="firstLineOfAddressError"
                  v-bind:validationMessage="firstLineOfAddressValidationMessage"
                  v-model="innerFirstLineOfAddress"
                  v-on:input="valueChange($event, 'firstLineOfAddress')"
                ></form-input>
              </div>

              <div class="cell">
                <form-input
                  name="second-line-of-address"
                  v-bind:id="'secondLineOfAddress'"
                  v-bind:label="renderText(secondLineOfAddressLabel, 'Street')"
                  v-bind:required="true"
                  v-bind:validationError="secondLineOfAddressError"
                  v-bind:validationMessage="secondLineOfAddressValidationMessage"
                  v-model="innerSecondLineOfAddress"
                  v-on:input="valueChange($event, 'secondLineOfAddress')"
                ></form-input>
              </div>
              <div class="cell">
                <form-input
                  name="third-line-of-address"
                  v-bind:id="'thirdLineOfAddress'"
                  v-bind:label="renderText(thirdLineOfAddressLabel, 'Town / city')"
                  v-bind:required="true"
                  v-bind:validationError="thirdLineOfAddressError"
                  v-bind:validationMessage="thirdLineOfAddressValidationMessage"
                  v-model="innerThirdLineOfAddress"
                  v-on:input="valueChange($event, 'thirdLineOfAddress')"
                ></form-input>
              </div>
              <div class="cell">
                <form-input
                  name="postcode"
                  v-bind:id="'postcode'"
                  v-bind:label="renderText(postcodeLabel, 'Postcode')"
                  v-bind:required="true"
                  v-bind:validationError="postcodeError"
                  v-bind:validationMessage="postcodeValidationMessage"
                  v-model="innerPostcode"
                  v-on:input="valueChange($event, 'postcode')"
                ></form-input>
              </div>
            </div>
          </div>
          <resources-summary
            v-bind:requestedItems="requestedItems"
            v-bind:summaryHeading="summaryHeading"
            v-on:removeItem="removeItem"
            v-on:updateQuantity="updateQuantity"
          ></resources-summary>
          <div class="c-simple-form-box__actions">
            <button
              class="c-button c-button--neutral"
              type="button"
              v-on:click="prevStep"
            >{{renderText(backButtonText, 'Back') }}</button>
            <button
              class="c-button c-button--brand"
              type="submit"
              v-on:click="checkForm"
            >{{renderText(submitButtonText, 'Submit')}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import FormInput from "./elements/FormInput";
import FormSelect from "./elements/FormSelect";
import ResourcesSummary from "./ResourcesSummary";

export default {
  components: {
    FormInput,
    FormSelect,
    ResourcesSummary,
  },
  props: {
    emailLabel: {
      required: true,
      type: String,
    },
    extraDetailsLabel: {
      required: true,
      type: String,
    },
    firstNameLabel: {
      required: true,
      type: String,
    },
    firstLineOfAddressLabel: {
      required: true,
      type: String,
    },
    secondLineOfAddressLabel: {
      required: true,
      type: String,
    },
    thirdLineOfAddressLabel: {
      required: true,
      type: String,
    },
    postcodeLabel: {
      required: true,
      type: String,
    },
    otherTitleLabel: {
      required: true,
      type: String,
    },
    numberLabel: {
      required: true,
      type: String,
    },
    lastNameLabel: {
      required: true,
      type: String,
    },
    titleLabel: {
      required: true,
      type: String,
    },
    backButtonText: {
      required: true,
      type: String,
    },
    submitButtonText: {
      required: true,
      type: String,
    },
    email: {
      required: true,
      type: String,
    },
    extraDetails: {
      required: true,
      type: String,
    },
    firstName: {
      required: true,
      type: String,
    },
    otherTitle: {
      required: true,
      type: String,
    },
    number: {
      required: true,
      type: String,
    },
    lastName: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    emailValidationMessage: {
      required: true,
      type: String,
    },
    extraDetailsValidationMessage: {
      required: true,
      type: String,
    },
    firstNameValidationMessage: {
      required: true,
      type: String,
    },
    firstLineOfAddressValidationMessage: {
      required: true,
      type: String,
    },
    lastNameValidationMessage: {
      required: true,
      type: String,
    },
    numberValidationMessage: {
      required: true,
      type: String,
    },
    otherTitleValidationMessage: {
      required: true,
      type: String,
    },
    postcodeValidationMessage: {
      required: true,
      type: String,
    },
    secondLineOfAddressValidationMessage: {
      required: true,
      type: String,
    },
    thirdLineOfAddressValidationMessage: {
      required: true,
      type: String,
    },
    titleValidationMessage: {
      required: true,
      type: String,
    },
    headingBlockOne: {
      required: false,
      type: String,
    },
    headingBlockTwo: {
      required: false,
      type: String,
    },
    firstLineOfAddress: {
      required: true,
      type: String,
    },
    requestedItems: {
      required: false,
      type: Array,
    },
    secondLineOfAddress: {
      required: true,
      type: String,
    },
    summaryHeading: {
      required: false,
      type: String,
    },
    thirdLineOfAddress: {
      required: true,
      type: String,
    },
    postcode: {
      required: true,
      type: String,
    },
  },
  watch: {
    email(newVal) {
      this.innerEmail = newVal;
    },
    extraDetails(newVal) {
      this.innerExtraDetails = newVal;
    },
    firstName(newVal) {
      this.innerFirstName = newVal;
    },
    firstLineOfAddress(newVal) {
      this.innerFirstLineOfAddress = newVal;
    },
    innerEmail(newVal) {
      this.valueChange(newVal, "email");
    },
    innerExtraDetails(newVal) {
      this.valueChange(newVal, "extraDetails");
    },
    innerFirstName(newVal) {
      this.valueChange(newVal, "firstName");
    },
    innerFirstLineOfAddress(newVal) {
      this.valueChange(newVal, "firstLineOfAddress");
    },
    innerOtherTitle(newVal) {
      this.valueChange(newVal, "otherTitle");
    },
    innerPostcode(newVal) {
      this.valueChange(newVal, "postcode");
    },
    innerNumber(newVal) {
      this.valueChange(newVal, "number");
    },
    innerSecondLineOfAddress(newVal) {
      this.valueChange(newVal, "secondLineOfAddress");
    },
    innerLastName(newVal) {
      this.valueChange(newVal, "lastName");
    },
    innerThirdLineOfAddress(newVal) {
      this.valueChange(newVal, "thirdLineOfAddress");
    },
    innerTitle(newVal) {
      this.valueChange(newVal, "title");
    },
    otherTitle(newVal) {
      this.innerOtherTitle = newVal;
    },
    postcode(newVal) {
      this.innerPostcode = newVal;
    },
    number(newVal) {
      this.innerNumber = newVal;
    },
    secondLineOfAddress(newVal) {
      this.innerSecondLineOfAddress = newVal;
    },
    lastName(newVal) {
      this.innerLastName = newVal;
    },
    thirdLineOfAddress(newVal) {
      this.innerThirdLineOfAddress = newVal;
    },
    title(newVal) {
      this.innerTitle = newVal;
    },
  },
  computed: {
    emailError() {
      return (
        (this.detailsSubmitted === true &&
          this.email !== "" &&
          this.validEmail(this.email) === false) ||
        (this.detailsSubmitted === true && this.email === "")
      );
    },
    extraDetailsError() {
      return this.detailsSubmitted === true && this.extraDetails === "";
    },
    firstNameError() {
      return this.detailsSubmitted === true && this.firstName === "";
    },
    firstLineOfAddressError() {
      return this.detailsSubmitted === true && this.firstLineOfAddress === "";
    },
    otherTitleError() {
      return (
        this.detailsSubmitted === true &&
        this.otherTitle === "" &&
        this.title === "Other"
      );
    },
    postcodeError() {
      return this.detailsSubmitted === true && this.postcode === "";
    },
    numberError() {
      return this.detailsSubmitted === true && this.number === "";
    },
    secondLineOfAddressError() {
      return this.detailsSubmitted === true && this.secondLineOfAddress === "";
    },
    showOtherTitle() {
      return this.title === "Other";
    },
    lastNameError() {
      return this.detailsSubmitted === true && this.lastName === "";
    },
    thirdLineOfAddressError() {
      return this.detailsSubmitted === true && this.thirdLineOfAddress === "";
    },
    titleError() {
      return this.detailsSubmitted === true && this.title === "";
    },
  },
  created() {
    this.innerEmail = this.email;
    this.innerExtraDetails = this.extraDetails;
    this.innerFirstName = this.firstName;
    this.innerFirstLineOfAddress = this.firstLineOfAddress;
    this.innerOtherTitle = this.otherTitle;
    this.innerPostcode = this.postcode;
    this.innerNumber = this.number;
    this.innerSecondLineOfAddress = this.secondLineOfAddress;
    this.innerLastName = this.lastName;
    this.innerThirdLineOfAddress = this.thirdLineOfAddress;
    this.innerTitle = this.title;
  },
  data() {
    return {
      detailsSubmitted: false,
      innerEmail: "",
      innerExtraDetails: "",
      innerFirstName: "",
      innerFirstLineOfAddress: "",
      innerOtherTitle: "",
      innerPostcode: "",
      innerNumber: "",
      innerSecondLineOfAddress: "",
      innerLastName: "",
      innerThirdLineOfAddress: "",
      innerTitle: "",
      titleOptions: [
        {
          label: "Mr",
          value: "Mr",
        },
        {
          label: "Mrs",
          value: "Mrs",
        },
        {
          label: "Miss",
          value: "Miss",
        },
        {
          label: "Ms",
          value: "Ms",
        },
        {
          label: "Other",
          value: "Other",
        },
      ],
    };
  },
  methods: {
    checkForm(e) {
      e.preventDefault();
      this.detailsSubmitted = true;
      if (
        this.emailError === false &&
        this.extraDetailsError === false &&
        this.firstNameError === false &&
        this.firstLineOfAddressError === false &&
        this.otherTitleError === false &&
        this.postcodeError === false &&
        this.numberError === false &&
        this.secondLineOfAddressError === false &&
        this.lastNameError === false &&
        this.thirdLineOfAddressError === false &&
        this.titleError === false
      ) {
        this.$emit("collateDetails");
      }
    },
    prevStep() {
      this.$emit("prevStep");
    },
    removeItem(id) {
      this.$emit("removeItem", id);
    },
    renderText(text, fallback) {
      if(!text || text === "") {
        return fallback;
      }
      else {
        return text;
      }
    },
    resetForm() {
      this.innerEmail = "";
      this.innerExtraDetails = "";
      this.innerFirstName = "";
      this.innerFirstLineOfAddress = "";
      this.innerOtherTitle = "";
      this.innerPostcode = "";
      this.innerNumber = "";
      this.innerSecondLineOfAddress = "";
      this.innerLastName = "";
      this.innerThirdLineOfAddress = "";
      this.innerTitle = "";
    },
    updateQuantity(id, value) {
      console.log("form action", id);
      this.$emit("updateQuantity", id, value);
    },
    validEmail(email) {
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegex.test(email);
    },
    valueChange(value, key) {
      this.$emit("valueChange", key, value);
    },
  },
};
</script>
 


// WEBPACK FOOTER //
// src/components/components/partnerhub/resources/form/Form.vue